import { createAsyncThunk, createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { ntxAPI } from '../../../API/axiosNeatex';
import type { ProductsModels } from './ProductsModels';

export const addProducts = createAsyncThunk(
  'MrpProducts/addProducts',
  async (item: any, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await ntxAPI.post('MRP/AddProducts', item);
      await dispatch(getProductsList());
      return data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const updateProducts = createAsyncThunk(
  'MrpProducts/updateProducts',
  async (item: any, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await ntxAPI.post('MRP/UpdateProducts', item);
      await dispatch(getProductsList());

      return data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getProductsList = createAsyncThunk(
  'MrpProducts/getProductsList',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.get('MRP/GetProductsList');
      if (data.succeeded) {
        return data.data;
      } else {
        return rejectWithValue(data?.message || 'هناك خطأ');
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getProductsById = createAsyncThunk(
  'MrpProducts/getProductsById',
  async (id: string, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.get('MRP/GetProductsById', { params: { id: id } });
      if (data.succeeded) {
        return data.data;
      } else {
        return rejectWithValue(data?.message || 'هناك خطأ');
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

const initialState: {
  ProductsList: ProductsModels[];
  ProductsById: ProductsModels;
  loading: boolean;
  loadingById: boolean;
  error: any | null;
} = {
  ProductsList: [],
  ProductsById: {} as ProductsModels,
  loading: false,
  loadingById: false,
  error: null,
};

const ProductsSlice = createSlice({
  name: 'MrpProducts',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder

      .addCase(getProductsList.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getProductsList.fulfilled, (state, action: PayloadAction<ProductsModels[]>) => {
        state.loading = false;
        state.ProductsList = action.payload;
      })
      .addCase(getProductsList.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      })
      //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
      .addCase(getProductsById.pending, (state, action) => {
        state.loadingById = true;
      })
      .addCase(getProductsById.fulfilled, (state, action: PayloadAction<ProductsModels>) => {
        state.loadingById = false;
        state.ProductsById = action.payload;
      })
      .addCase(getProductsById.rejected, (state, action: PayloadAction<any>) => {
        state.loadingById = false;
        state.error = action.payload;
      });
  },
});

export default ProductsSlice.reducer;
